<div class="border rounded-large nordic-blue-300-border overflow-hidden">
  <div class="title grey-100-bg white-text ps-medium-x ps-xsmall-y nordic-blue-900-text">
    {{ title }}
  </div>
  <div class="content ps-medium-y ps-medium-r">
    <ng-content />
  </div>
</div>
